import React from 'react';

const BI = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_194"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_194)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#D0091E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0L10 8L0 15V0ZM21 0L11 8L21 15V0Z"
        fill="#08B731"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.158 6.456L0 1.5V0H1.5L8.347 4.74C8.94 4.276 9.687 4 10.5 4C11.312 4 12.06 4.276 12.653 4.74L19.5 0H21V1.5L13.842 6.456C13.945 6.786 14 7.136 14 7.5C14 7.864 13.945 8.214 13.842 8.544L21 13.5V15H19.5L12.653 10.26C12.059 10.724 11.313 11 10.5 11C9.688 11 8.94 10.724 8.347 10.26L1.5 15H0V13.5L7.158 8.544C7.055 8.214 7 7.864 7 7.5C7 7.136 7.055 6.786 7.158 6.456Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 6H11V7H10V6ZM11 8H12V9H11V8ZM9 8H10V9H9V8Z"
        fill="#D0091E"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default BI;
